import { render, staticRenderFns } from "./IncludeUnappliedToggle.vue?vue&type=template&id=637b59ca"
import script from "./IncludeUnappliedToggle.vue?vue&type=script&lang=ts"
export * from "./IncludeUnappliedToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports